<template>
  <div :class="[classes, additionalClasses]">
    <div
      v-if="$slots.heading"
      :class="'panel-heading ' + additionalHeadingClasses"
    >
      <!-- @slot Optionaler Slot für eine Überschrift, panel-heading wird nicht dargestellt, wenn er leer ist.
      ```<template #heading>Überschrift hier</template>```
       -->
      <div class="row">
        <div :class="{'col-md-8': collapsible, 'col-md-12': !collapsible}">
          <h4
            class="panel-title"
            @click="open = !open"
          >
            <slot name="heading" />
          </h4>
        </div>
        <div
          v-if="collapsible"
          class="col-md-4 item_groups text-right"
        >
          <div class="item">
            <span
              v-if="!open"
              class="btn ed_panel_collapsible_indicator fa fa-chevron-down"
              data-original-title="Bereich anzeigen/ausblenden"
              data-toggle="tooltip"
              title=""
              @click="open = true"
            />
            <span
              v-if="open"
              class="btn ed_panel_collapsible_indicator fa fa-chevron-up"
              data-original-title="Bereich anzeigen/ausblenden"
              data-toggle="tooltip"
              title=""
              @click="open = false"
            />
          </div>
        </div>
      </div>

    </div>
    <div
      v-show="open || !collapsible"
      :class="'form panel-body ' + additionalBodyClasses"
    >
      <slot />
    </div>
    <div
      v-if="$slots.footer && open"
      class="panel-footer"
    >
      <!-- @slot Optionaler Slot für eine Fußzeile. panel-footer wird nicht dargestellt, wenn er leer ist.
            ```<template #footer>Fußzeile hier</template>```
            -->
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
/**
 * Eine Darstellungskomponente für Panels
 * @displayName BasePanel
 */
export default {
  name: 'BasePanel',
  props: {
    /**
     * The modifier for the panel
     * @values default, primary, success, info, warning, danger
     */
    modifier: {
      type: String,
      default: 'default'
    },
    /**
     * Macht, was sie behauptet zu machen
     */
    additionalClasses: {
      type: String,
      default: ''
    },
    /**
     * Macht, was sie behauptet zu machen
     */
    additionalHeadingClasses: {
      type: String,
      default: ''
    },
    /**
     * Macht, was sie behauptet zu machen
     */
    additionalBodyClasses: {
      type: String,
      default: ''
    },
    /**
     * Soll das Panel aufklappbar sein?
     */
    collapsible: {
      type: Boolean,
      default: false
    },
    /**
     * Soll das Panel (falls aufklappbar) zuerst geschlossen sein?
     */
    initiallyClosed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: true
    }
  },
  computed: {
    classes() {
      return 'ed_panel panel panel-' + this.modifier
    }
  },
  mounted() {
    if (this.initiallyClosed) {
      this.open = false;
    }
  }
}
</script>

<style lang="less">
.panel--popup {
  margin: 0 !important;

  .panel-heading {
    overflow: hidden;
  }
}

.panel--minimal {
  border: 3px solid #fff !important;
  box-shadow: none;
  position: relative;

  .panel-body {
    padding: 0;
  }

  .panel-footer {
    border-top: 3px solid #fff;
    padding: 0 0 0 5px;
  }

  .panel-heading {
    position: absolute;
    top: 10px;
    left: 10px;
    background: transparent;
    padding: 0;
  }

  .footer-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
  }

  .item {
    font-size: 20px;
    min-width: unset;
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    align-self: flex-end;
    padding: 0;
    line-height: 1.65em;
  }
}

.panel-heading small {
  font-size: 65%;
  opacity: 0.8;
}

.panel--invisible {
  &,
  & > .panel-body,
  & > .panel-heading,
  & > .panel-footer {
    border: none;
    box-shadow: none;
    background-color: transparent;
    padding: 0;
    margin: 0;
  }
}

.panel--focus {
  position: relative;
  z-index: 9999;
  border: none;
  box-shadow: none;
}

.panel-heading--grey {
  background-color: #f5f5f5 !important;
}
</style>